<template>
  <section class="multi-steps-section" :class="classObject">
    <div class="container">
      <div class="multi-steps-content">
        <SectionHeader
          :title="data.title"
          :subcaption="data.permissions"
          :description="data.description"
        />
        <CoolLightBox
          :items="getImages ? getImages : []"
          :index="coolboxIndex"
          :effect="'fade'"
          :useZoomBar="true"
          @close="coolboxIndex = null"
        >
        </CoolLightBox>
        <div class="steps-content">
          <div class="slide-wrapper">
            <slick ref="slick" :options="slickOptions">
              <div class="slider-content" @click="openImage(0)" v-if="solo">
                <div class="img-wrap">
                  <div class="hover-bg">
                    <div class="hover-text">
                      Click to Zoom
                    </div>
                  </div>
                  <img :src="data.singleImage" />
                </div>
              </div>
              <div
                class="slider-content"
                :key="index"
                v-for="(step, index) in data.steps"
                @click="openImage(index)"
                v-else
              >
                <div class="slide-title">
                  {{ step.title }}
                </div>
                <div class="img-wrap">
                  <div class="hover-bg">
                    <div class="hover-text">
                      Click to Zoom
                    </div>
                  </div>
                  <img :src="step.src" />
                </div>
              </div>
            </slick>
          </div>
          <div class="steps-info-list">
            <div
              v-for="(step, index) in data.steps"
              :key="index"
              data-aos="zoom-in"
              :data-aos-delay="150 * index"
              class="info-detail"
            >
              <div class="info-content">
                <div class="icon-wrap">
                  <img
                    :src="require(`@/assets/icons/${step.icon}`)"
                    alt="step"
                  />
                </div>
                <div class="info-title">
                  {{ step.title }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Slick from "vue-slick";
import SectionHeader from "@/pageComponents/globalUi/section-header";

export default {
  props: ["data", "single", "extraClass"],
  components: {
    SectionHeader,
    Slick
  },
  data() {
    return {
      coolboxIndex: null,
      solo: this.single ? this.single : false,
      title: this.data.title,
      description: this.data.description,
      slickOptions: {
        arrows: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    };
  },
  computed: {
    getImages() {
      if (this.solo) {
        return this.data.singleImage;
      } else {
        return this.data.steps;
      }
    },
    classObject() {
      return this.extraClass ? this.extraClass : "";
    }
  },
  methods: {
    next: function() {
      this.$refs.slick.next();
    },

    prev: function() {
      this.$refs.slick.prev();
    },

    reInit: function() {
      // Helpful if you have to deal with v-for to update dynamic lists
      this.$nextTick(() => {
        this.$refs.slick.reSlick();
      });
    },
    openImage(index) {
      this.coolboxIndex = index;
    }
  }
};
</script>

<style lang="scss">
@import "@/scss/_variable.scss";
@import "@/scss/_mixins.scss";
.multi-steps-section {
  .multi-steps-content {
    .steps-content {
      position: relative;
      margin-top: 80px;
      min-height: 500px;
      .slide-wrapper {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate3d(-50%, -50%, 0);
        width: 70%;
        max-width: 700px;
        height: 550px;
        .slick-slider {
          height: 100%;
          .slick-track {
            height: 100%;
          }
          .slick-list {
            height: 100%;
            .slick-slide {
              height: 100%;
              > div {
                height: 100%;
              }
            }
          }
          .slick-dots {
            bottom: -30px;
            li {
              button {
                &::before {
                  background: #3f3d56;
                  border-color: #3f3d56;
                }
              }
              &.slick-active {
                width: 25px;
                button {
                  &:before {
                    opacity: 1;
                    background: #de3527;
                    border-color: #de3527;
                    width: 25px;
                    border-radius: 50px;
                  }
                }
              }
            }
          }
        }
        .slider-content {
          height: 100%;
          .slide-title {
            font-family: $heading-font;
            text-align: center;
            font-size: 28px;
            margin-bottom: 15px;
            color: #212164;
          }
          .img-wrap {
            height: 100%;
            padding: 0 20px 20px;
            position: relative;
            cursor: zoom-in;
            .hover-bg {
              position: absolute;
              width: calc(100% - 40px);
              height: calc(100% - 70px);
              display: flex;
              justify-content: center;
              align-items: center;
              z-index: 1;
              opacity: 0;
              border-radius: 6px;
              background: rgba(0, 0, 0, 0.4);
              @include customTransition(0.3s, cubic-bezier(0.44, 0.9, 1, 1));
              .hover-text {
                transform: translateY(-20px);
                font-family: $content-font;
                font-weight: 600;
                text-align: center;
                color: #ffffff;
                font-size: 28px;
              }
            }
            img {
              height: calc(100% - 50px);
              border-radius: 6px;
              @include boxShadow(0, 0px, 20px, 1px, rgba(0, 0, 0, 0.1));
              object-position: top;
            }
            &:hover {
              .hover-bg {
                opacity: 1;
              }
            }
          }
        }
      }
      .steps-info-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding: 100px 0;
        .info-detail {
          width: 50%;
          display: flex;
          margin-bottom: 30px;
          .info-content {
            width: 175px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .icon-wrap {
              width: 65px;
              height: 65px;
              display: flex;
              justify-content: center;
              align-items: center;
              background: #ffffff;
              border-radius: 50%;
              @include boxShadow(3px, 3px, 20px, 0px, rgba(33, 33, 100, 0.1));
              img {
                width: 25px;
              }
            }
            .info-title {
              margin-top: 10px;
              font-family: $content-font;
              font-size: 16px;
              color: #212164;
              font-weight: bold;
              text-align: center;
            }
          }
          &:nth-child(even) {
            justify-content: flex-end;
          }
          &:nth-last-child(2),
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 991px) {
  .multi-steps-section {
    .multi-steps-content {
      .steps-content {
        display: flex;
        justify-content: flex-end;
        flex-direction: column-reverse;
        margin-top: 50px;
        .slide-wrapper {
          position: relative;
          left: 0;
          top: 0;
          transform: none;
          width: 80%;
          margin: 0 auto;
          max-width: 100%;
          height: initial;
          .slider-content {
            .slide-title {
              font-size: 24px;
            }
          }
        }
        .steps-info-list {
          padding: 0 0 10px 0;
          align-items: flex-start;
          .info-detail {
            width: 15%;
            .info-content {
              .info-title {
                font-size: 14px;
              }
            }
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .multi-steps-section {
    .multi-steps-content {
      .steps-content {
        margin-top: 40px;
        .slide-wrapper {
          width: 90%;
        }
        .steps-info-list {
          .info-detail {
            width: 15%;
            .info-content {
              .icon-wrap {
                width: 60px;
                height: 60px;
                img {
                  width: 23px;
                }
              }
              .info-title {
                font-size: 14px;
              }
            }
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 575px) {
  .multi-steps-section {
    .multi-steps-content {
      .steps-content {
        margin-top: 30px;
        .slide-wrapper {
          .slider-content {
            .slide-title {
              font-size: 20px;
              margin-bottom: 5px;
            }
            .img-wrap {
              padding: 0 10px 10px;
            }
          }
        }
        .steps-info-list {
          .info-detail {
            width: 33%;
            margin-bottom: 30px !important;
          }
        }
      }
    }
    &.no-padding-bottom {
      padding-bottom: 0;
    }
  }
}
</style>
